var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: { padding: "40px 0 40px 0", "background-color": "#101010" }
    },
    [
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c("span", { staticClass: "u-connect-bold" }, [_vm._v("U-Connect ")]),
          _vm._v(" "),
          _c("span", { staticClass: "u-connect-regular" }, [
            _vm._v("- Connect your clients to a property today")
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                padding: "0 16px 16px 16px"
              },
              attrs: { span: 24 }
            },
            [
              _c(
                "el-button",
                { staticClass: "u-connect-btn", attrs: { type: "primary" } },
                [_vm._v("Discover more")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6270b2d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6270b2d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/discoverMore.vue
// module id = null
// module chunks = 